import { NavBar } from '../components/Layout/NavBar';
import { Footer } from '../components/Layout/Footer';
import Internship from '../components/LandingPages/internship';

const InternshipPage = () => {
    return (
        <div>
            <NavBar />
            <Internship />
            <Footer />
        </div>
    );
};

export default InternshipPage;